import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

export const usePublicData = () => {
  const [data, setData] = useState({
    site: null,
    about: null,
    projects: [],
    services: [],
    testimonials: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [site, about, projects, services, testimonials] = await Promise.all([
        api.getSite(),
        api.getAbout(),
        api.listProjects(),
        api.listServices(),
        api.listTestimonials(),
      ]);
      setData({ site, about, projects, services, testimonials });
    } catch (e) {
      console.error("Failed to load site data", e);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { ...data, loading, error, reload: load };
};
